// Panel "Input Rotasi Cepat" (Rotasi Klinik, tab Per Peserta) -- fungsi murni.
// Aturan sebenarnya ditegakkan backend (rotasi_cepat.py + POST /rotasi-klinik/bulk-create);
// di sini hanya mempermudah: hitung kuota, isi otomatis tanggal, petakan galat per baris.

export const BLOK_STASE_RSCM = "stase_rscm";
export const BLOK_STASE_LUAR = "stase_luar";
export const BLOK_JAGA = "jaga";
export const BLOK_URUT = [BLOK_STASE_RSCM, BLOK_STASE_LUAR, BLOK_JAGA];
export const LABEL_BLOK = {
    [BLOK_STASE_RSCM]: "Stase RSCM",
    [BLOK_STASE_LUAR]: "Stase Luar / RS Jejaring",
    [BLOK_JAGA]: "Jaga",
};
const ISIAN = ["departemen_id", "divisi_id", "instalasi_id", "nama_rs", "tanggal_mulai", "tanggal_akhir"];

let urut = 0;
export const barisBaru = () => ({
    key: `b${++urut}`, departemen_id: "", divisi_id: "", instalasi_id: "", nama_rs: "", tanggal_mulai: "", tanggal_akhir: "",
});

export const barisTerisi = (b) => ISIAN.some((k) => String(b[k] ?? "").trim() !== "");

export const jumlahTerisi = (form) => BLOK_URUT.reduce((n, blok) => n + form[blok].filter(barisTerisi).length, 0);

// Kuota: tersimpan (dari server) + baris di formulir. "terpakai" = baris terisi saja; "+" dinilai dgn
// SEMUA baris yang tampil supaya jumlah baris tidak pernah melebihi sisa kuota.
export function hitungKuota(form, terpakai, maks) {
    const stasePakai = terpakai.stase + form[BLOK_STASE_RSCM].filter(barisTerisi).length
        + form[BLOK_STASE_LUAR].filter(barisTerisi).length;
    const jagaPakai = terpakai.jaga + form[BLOK_JAGA].filter(barisTerisi).length;
    const staseTampil = terpakai.stase + form[BLOK_STASE_RSCM].length + form[BLOK_STASE_LUAR].length;
    const jagaTampil = terpakai.jaga + form[BLOK_JAGA].length;
    return {
        stase: { terpakai: stasePakai, maks: maks.stase, bisaTambah: staseTampil < maks.stase },
        jaga: { terpakai: jagaPakai, maks: maks.jaga, bisaTambah: jagaTampil < maks.jaga },
    };
}

// Badan request: SEMUA baris dikirim (termasuk kosong) supaya indeks galat dari server = urutan di layar.
export function badanSimpan(form, pesertaId, bulan, tahun, cekSaja = false) {
    const bersih = (b) => Object.fromEntries(ISIAN.map((k) => [k, String(b[k] ?? "").trim() || null]));
    return {
        peserta_id: pesertaId, bulan: Number(bulan), tahun: Number(tahun), cek_saja: cekSaja,
        ...Object.fromEntries(BLOK_URUT.map((blok) => [blok, form[blok].map(bersih)])),
    };
}

// detail.baris [{blok, indeks, alasan}] -> { "<key baris>": ["alasan", ...] }. Dipakai juga utk
// peringatan [{blok, indeks, pesan}] dgn field = "pesan".
export function petakanGalat(form, daftar, field = "alasan") {
    const hasil = {};
    (daftar || []).forEach((g) => {
        const baris = form[g.blok]?.[g.indeks];
        if (!baris) return;
        hasil[baris.key] = [...(hasil[baris.key] || []), g[field]];
    });
    return hasil;
}

// Peserta "Belum Isi" berikutnya pada daftar yang sedang tampil (berputar ke awal), selain yang sekarang.
// Peserta tidak wajib isi (Stase MDU-MDK/Penelitian/Belum Stase, `wajib_rotasi` false dari server) dilewati.
export const belumIsiWajib = (p) => !p.has_rotasi && p.wajib_rotasi !== false;
export function pesertaBelumBerikutnya(daftar, idSekarang) {
    const i = daftar.findIndex((p) => p.id === idSekarang);
    const urutan = [...daftar.slice(i + 1), ...daftar.slice(0, Math.max(i, 0))];
    return urutan.find((p) => belumIsiWajib(p) && p.id !== idSekarang)?.id || null;
}

export const STATUS_ISI = ["semua", "belum", "sudah"];
export const statusIsiDariParam = (v) => (STATUS_ISI.includes(v) ? v : "semua");
